import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  name: string().trim().required('Field is required').max(100, 'Max length - 100 symbols'),
  content: string().trim().required('Field is required').max(2000, 'Max length - 2000 symbols'),
});

export default yupResolver(validationSchema);
